/* The equipment grid — KANON `Cwiczenia` 17.09.2026, the panel's `Sprzęt` card.
 *
 * Four across, with the piece's own photograph on a square plate and its name under it. The card
 * around this is the LAST one in the column, so it holds its shorter shape and grows downward into
 * the column's own scroll rather than reserving room for a movement that needs six pieces. */

/* Four across on the preview panel's 366px, and SIX on the theatre's wider rail — which lands the
 * tile at the canon's own ~72px there rather than stretching it to 112. `--ex-equip-columns` is the
 * one hook a caller may resize through, set on the same element as the section's own class; a
 * second stylesheet redeclaring `grid-template-columns` would be settled by chunk order. */
.grid {
  display: grid;
  grid-template-columns: repeat(var(--ex-equip-columns, 4), 1fr);
  gap: var(--space-10px);
  justify-items: start;
}

/* `width: 100%`, and it is a RESERVE rather than a tidier spelling.
 *
 * The tile is shrink-to-fit inside a `justify-items: start` track, and the plate inside it is
 * `width: 100%` of that — so the tile's width was decided by the widest thing in it, which before
 * the photograph arrives is the LABEL and after it arrives is the image's 512px natural width
 * clamped to the track. The tile therefore grew from about 36px to the track's 83.5 the moment the
 * file landed, the plate's `aspect-ratio: 1` turned that into 47px of height, and the name under it
 * moved down by exactly that. Measured on the preview panel's first two tiles at 46.9 and 46.3px.
 *
 * Filling the track makes the box the same before and after, which is the loading policy's own
 * rule. The settled drawing is unchanged — the track is what a tile with a photograph already
 * measured; what changes is a tile whose picture is missing, which now stands the same width as its
 * neighbours instead of shrinking to its own caption. */
.tile {
  display: flex;
  flex-direction: column;
  gap: var(--space-6px);
  align-items: center;
  width: 100%;
  min-height: var(--h-ex-equip-tile);
}

/* The plate. `--bg-card` in both themes rather than the specimen's literal white: the pictures are
 * square product shots on a white ground and `object-fit: cover` fills the box, so the plate is only
 * ever seen while the file is in flight or after it fails — where a theme-blind white would be a
 * bright square on a near-black canvas. It is what the builder's own equipment tiles already do. */
.plate {
  display: grid;
  place-items: center;
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  background: var(--bg-card);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-mark);
}

.photo {
  display: block;
  width: 100%;
  height: 100%;
}

.letter {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  font-size: var(--fs-micro);
  font-style: normal;
  font-weight: var(--fw-bold);
  line-height: var(--lh-none);
  color: var(--text-2);
  background: var(--bg-inset);
}

.label {
  font-size: var(--fs-micro);
  font-weight: var(--fw-bold);
  line-height: var(--lh-display);
  text-align: center;
  color: var(--text);
}

.empty {
  margin: var(--space-0);
  font-size: var(--fs-micro);
  font-weight: var(--fw-medium);
  line-height: var(--lh-normal);
  color: var(--text-3);
}
